import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import {
  AppBar,
  Toolbar,
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import {
  AI_getAnnouncementList,
  AI_getPopupAnnouncementList,
  AI_UpdatePopupAnnouncementList,
} from "APIs/announcement";
import { useInstance } from "easy-redux-http-call";
import { AI_getUserData } from "APIs/user";
import AnnouncementStrip from "./AnnouncementStrip";
import HeaderContent from "./HeaderContent";

const useStyle = makeStyles((theme) => ({
  AnnouncementTitle: {
    fontSize: "30px",
    display: "flex",
    justifyContent: "center",
  },
  dialogContainer: {
    "& > div:nth-child(3)": {
      "& > div": {
        width: "700px !important",
      },
    },
  },
}));



const Header = ({ open, handleDrawerToggle }) => {
  const Transition = React.useMemo(
    () =>
      React.forwardRef(function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />;
      }),
    [] 
  );
  
  const theme = useTheme();
  const classes = useStyle();
  const { drawerOpen } = useSelector((state) => state.menu);
  const employeeAnnouncementPopup = useInstance(AI_getPopupAnnouncementList);
  const userData = useInstance(AI_getUserData);
  const [isRead, setIsRead] = React.useState(false);

  const Is_Read = useMemo(() => {
    return employeeAnnouncementPopup?.data?.publicAnnouncement?.find(
      (Emp) => Emp
    );
  }, [employeeAnnouncementPopup]);

  const Desc = useMemo(() => {
    return employeeAnnouncementPopup?.data?.matchedAnnouncements?.find(
      (desc) => desc
    );
  }, [employeeAnnouncementPopup]);

  const handleAnnounceMentDialogClose = async () => {
    if (Is_Read?.announcement_id && userData?.data?.user?.employee_id) {
      await AI_UpdatePopupAnnouncementList.call({
        params: {
          announcement_id: Is_Read?.announcement_id,
          employee_id: userData?.data?.user?.employee_id,
        },
      });
      setIsRead(false);
    } else {
      console.log("Employee ID not found!");
    }
  };

  useEffect(() => {
    if (userData?.data?.user?.employee_id) {
      AI_getPopupAnnouncementList.call({
        params: {
          employee_id: userData?.data?.user?.employee_id,
        },
      });
      setIsRead(true);
    }
  }, [userData?.data?.user?.employee_id]);

  const mainHeader = (
    <Toolbar style={{ justifyContent: "end" }}>
      <Grid
        style={{
          width: `calc(100% - ${drawerOpen ? "248px" : "38px"})`,
          transition: "all .5s ease-in-out",
          justifyContent: "space-between",
          display: "flex",
          paddingLeft: "22px",
        }}
      >
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            paddingTop: "10px",
            whiteSpace: "noWrap",
          }}
        >
          {useSelector((state) => state.menu.page)}
        </Typography>
        <AnnouncementStrip />
        <HeaderContent />
      </Grid>
    </Toolbar>
  );

  const appBar = {
    position: "fixed",
    color: "inherit",
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  };

  return (
    <>
      <AppBar {...appBar}>{mainHeader}</AppBar>
      <div>
        {Desc && isRead && (
          <Dialog
            open={isRead}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
            className={classes.dialogContainer}
          >
            <DialogTitle className={classes.AnnouncementTitle}>
              {Desc?.title}
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-slide-description"
                style={{ fontSize: "1.5rem" }}
              >
                {Desc?.description}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAnnounceMentDialogClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
};

export default Header;
